import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inline-block message-text-content container-with-short-meta-space" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "author mr-1"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = ["src"]

import {computed, ref} from 'vue';
import CoreUiHtmlify from "~/core-ui/vue/ui/CoreUiHtmlify.vue";
import {MESSAGE_BLOCK_PREFIX, MESSAGE_HTML_PREFIX} from "~/chat/ts/Constants";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import Random from "~/ts/library/Random";
import {STATIC_SERVER} from "~/core-ui/ts/Constants";
import OperatorApplicationPlatformInterface
    from "~/operatorApplication/ts/platform/OperatorApplicationPlatformInterface";
import CoreUiHtmlifySnippetEventInterface from "~/core-ui/vue/ui/CoreUiHtmlifySnippetEventInterface";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "OnlineMessageTextContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    htmlify: {},
    operatorApplicationPlatform: {},
    showSenderAndIconBeforeText: { type: Boolean },
    operator: {},
    showOperatorLogins: { type: Boolean, default: true },
    bbcode: { type: Boolean }
  },
  emits: ["height-change", "snippet"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let iframe = ref<HTMLIFrameElement>();

let instanceId = ref(Random.uid());

let text = computed(() => {
    let text = props.message.content.text;
    if (text) {
        if (text.indexOf(MESSAGE_HTML_PREFIX) == 0) {
            text = text.substr(MESSAGE_HTML_PREFIX.length);
        }
        if (text.indexOf(MESSAGE_BLOCK_PREFIX) == 0) {
            text = text.substr(MESSAGE_BLOCK_PREFIX.length);
        }
    }
    return text;
});

let isHtml = computed(() => {
    if (props.message.content.text) {
        return props.message.content.text.indexOf(MESSAGE_HTML_PREFIX) === 0;
    } else {
        return false;
    }
});

function getScrollbarStyle(background: string) {
    const scrollbarWidth = '10px';
    const scrollbarBorderWidth = '2px';
    return `
  body::-webkit-scrollbar-track {
    opacity: 0;
    background: transparent;
  }

  body::-webkit-scrollbar {
    width: ${scrollbarWidth};
    height: .8em;
  }

  body::-webkit-scrollbar-thumb {
    opacity: .2;
    background-color: #7a7a7a00;
    border-radius: 6px;
    border: ${scrollbarBorderWidth} solid ${background};
    transition: .1s ease background-color;
  }
  body:hover::-webkit-scrollbar-thumb {
    background-color: #7a7a7a4d;
  }
  body::-webkit-scrollbar-thumb:hover {
    background-color: #7a7a7a;
  }`;
}

function onIframeLoaded() {
    let background = window.getComputedStyle(iframe.value).getPropertyValue('--message-background-color');
    iframe.value.setAttribute("data-on-click-initialized", "1");
    let style = window.getComputedStyle(iframe.value.parentElement);
    let bodyStyle = iframe.value.contentDocument.body.style;
    for (let key in style) {
        if (style.hasOwnProperty(key)) {
            bodyStyle.setProperty(key, style[key]);
        }
    }

    let doc = iframe.value.contentDocument;

    bodyStyle.setProperty("width", "100%");
    bodyStyle.setProperty("height", "auto");
    let a = iframe.value.parentElement.querySelector("a");
    let styleTag = doc.createElement("style");
    styleTag.innerHTML = getScrollbarStyle(background);
    doc.body.appendChild(styleTag);

    if (a) {
        let style = window.getComputedStyle(a);
        styleTag.innerHTML = `${styleTag.innerHTML}
            a { ${style.cssText}; width: auto; height: auto; }
            a:hover {text-decoration: none; cursor: pointer; }
            img { max-width: 100%; }
        `;
    }
    if (props.operatorApplicationPlatform) {
        doc.addEventListener("click", e => {
            e.preventDefault();
            e.stopPropagation();
            let target: HTMLLinkElement = e.target as HTMLLinkElement;
            if (target.tagName.toLowerCase() == "a") {
                if (target.href) {
                    props.operatorApplicationPlatform.openExternal(target.href);
                }
            }

        }, {capture: true});
    }

    iframe.value.style.height = doc.documentElement.scrollHeight + 1 + 'px';
    onHeightChange();
}

let iframeSrc = computed(() => {
    let html = `<base href="${STATIC_SERVER}" />${text.value}`;
    html += '<style>img {max-width: 100% !important; height: auto !important;}</style>'
    const blob = new Blob([html], {type: "text/html"});
    return URL.createObjectURL(blob);
});

let htmlifyComponent = computed(() => {
    return props.htmlify ? props.htmlify : CoreUiHtmlify;
});

function onHeightChange() {
    emits("height-change");
}


return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showSenderAndIconBeforeText)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _withDirectives(_createVNode(FontAwesomeIcon, {
            icon: __props.message.messageType.icon,
            class: "mr-1"
          }, null, 8, ["icon"]), [
            [_directive_my_tooltip, !__props.operator ? `${_unref(__)('От:')} ${__props.message.operatorLogin}` : null]
          ]),
          (__props.operator && !__props.message.isSendByClient)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.operator.fio + (__props.showOperatorLogins ? ` (${__props.operator.login})` : '') + ':'), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(isHtml))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(FontAwesomeIcon, { icon: "code" }),
            _createTextVNode(" " + _toDisplayString(_unref(__)('HTML-сообщение')) + ": ", 1)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-none" }, [
            _createElementVNode("a")
          ], -1)),
          _createElementVNode("iframe", {
            sandbox: "allow-same-origin",
            src: _unref(iframeSrc),
            ref_key: "iframe",
            ref: iframe,
            onLoad: onIframeLoaded
          }, null, 40, _hoisted_6)
        ]))
      : (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(htmlifyComponent)), {
          key: 2,
          value: _unref(text),
          tag: "span",
          emoji: "",
          links: "",
          bbcode: !__props.message.isSendByClient || __props.bbcode,
          nl2br: "",
          snippet: "",
          onHeightIncrease: onHeightChange,
          onSnippet: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('snippet', $event)))
        }, null, 40, ["value", "bbcode"]))
  ]))
}
}

})